import * as actionTypes from "./actionTypes";

export const updateActionsSort = val => {
  return {
    type: actionTypes.UPDATE_ACTION_SORT,
    val: val,
  };
};

export const updateActionsFilter = val => {
  return {
    type: actionTypes.UPDATE_ACTION_FILTER,
    val: val,
  };
};

export const updateObjectivesSort = val => {
  return {
    type: actionTypes.UPDATE_OBJECTIVE_SORT,
    val: val,
  };
};

export const updateObjectivesFilter = val => {
  return {
    type: actionTypes.UPDATE_OBJECTIVE_FILTER,
    val: val,
  };
};
export const updateGroupMetricsSort = val => {
  return {
    type: actionTypes.UPDATE_GROUP_METRICS_SORT,
    val: val,
  };
};

export const updateGroupMetricsFilter = val => {
  return {
    type: actionTypes.UPDATE_GROUP_METRICS_FILTER,
    val: val,
  };
};

export const updateTriviaSort = val => {
  return {
    type: actionTypes.UPDATE_TRIVIA_SORT,
    val: val,
  };
};

export const updateMessagesSort = val => {
  return {
    type: actionTypes.UPDATE_MESSAGES_SORT,
    val: val,
  };
};

export const updateTriviaResultSort = val => {
  return {
    type: actionTypes.UPDATE_TRIVIA_RESULT_SORT,
    val: val,
  };
};

export const updateMyTriviaSort = val => {
  return {
    type: actionTypes.UPDATE_MY_TRIVIA_SORT,
    val: val,
  };
};

export const updateLibrarySort = val => {
  return {
    type: actionTypes.UPDATE_LIBRARY_SORT,
    val: val,
  };
};
export const updateLibraryQuestionSort = val => {
  return {
    type: actionTypes.UPDATE_LIBRARY_QUESTIONS_SORT,
    val: val,
  };
};
